import { render, staticRenderFns } from "./MotivoAtendimentoManage.vue?vue&type=template&id=704f5d21&scoped=true"
import script from "./MotivoAtendimentoManage.vue?vue&type=script&lang=js"
export * from "./MotivoAtendimentoManage.vue?vue&type=script&lang=js"
import style0 from "./MotivoAtendimentoManage.vue?vue&type=style&index=0&id=704f5d21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704f5d21",
  null
  
)

export default component.exports